import React from 'react';
import PropTypes from 'prop-types';
import ItemCollection from '../ItemCollection';
import TeamMember from '../../molecules/TeamMember';

export default class Team extends React.Component {
  render() {
    const { as, team, showImage } = this.props;
    return (
      <React.Fragment>
        <ItemCollection
          collectionType={as === 'horizontalItem' ? 'items' : 'custom'}
          {...this.props}
        >
          {team.map(member => {
            const { image } = member;

            return (
              <TeamMember
                key={member.name}
                {...member}
                {...this.props}
                image={showImage ? image : ''}
              />
            );
          })}
        </ItemCollection>
      </React.Fragment>
    );
  }
}

Team.propTypes = {
  team: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      role: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
  as: PropTypes.oneOf(['verticalItem', 'horizontalItem', 'card']),
  buttonBasic: PropTypes.bool,
  buttonSize: PropTypes.string,
  cardInlinePhoto: PropTypes.oneOf(['left', false]),
  centerHeader: PropTypes.bool,
  header: PropTypes.string,
  imageCircular: PropTypes.bool,
  imageSize: PropTypes.string,
  itemButtonFloat: PropTypes.oneOf(['left', 'right']),
  itemCenterContent: PropTypes.bool,
  itemsDivided: PropTypes.bool,
  itemsPerRow: PropTypes.number,
  link: PropTypes.string,
  linkAs: PropTypes.oneOf(['button', 'header', 'none']),
  linkContent: PropTypes.string,
  onlyEvenRows: PropTypes.bool,
  showImage: PropTypes.bool,
  verticalItemAlign: PropTypes.oneOf(['left', 'right', 'center']),
};

Team.defaultProps = {
  as: 'horizontalItem',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  centerHeader: false,
  header: 'Our Team',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  itemsDivided: false,
  itemsPerRow: 3,
  link: '',
  linkAs: 'none',
  linkContent: '',
  onlyEvenRows: false,
  showImage: true,
  verticalItemAlign: 'center',
};

Team.propOptions = {};

Team.dataPropsMap = {
  team: ['business', 'team'],
};
